// setting default content to fill in placeholder data for fields not filled out
function ConsultingPrimaryModel({
  hero: {
    hero_src = '',
    hero_alt = '',
    hero_title = '',
    hero_description = '',
    hero_ctas = [],
  },
}) {
  return {
    hero: {
      hero_src,
      hero_alt,
      hero_title,
      hero_description,
      hero_ctas,
    },
  };
}

export default ConsultingPrimaryModel;
